import { observer } from 'mobx-react-lite';
import './FullScreenModal.scss';


const FullScreenModal = observer(({ children, footer = null, isOpen = false, onClose, className = '' }) => {
    var classes = `${className} `;
    if (isOpen) {
        classes += ' is-open ';
    } else {
        return null
    }

    return (<div className={`FullScreenModal__overlay ${classes}`}>
        <div className="FullScreenModal">
            <div className="FullScreenModal__content">
                {children}
            </div>
        </div>
    </ div>
    )
})
FullScreenModal.displayName = 'FullScreenModal';
export {
    FullScreenModal
}